module.exports = __webpack_public_path__ + "media/images/companies/tokyo_metro_ad-8e414e02b5504873b6737af2220c4414.jpg";